import { render, staticRenderFns } from "./StreamMessage.vue?vue&type=template&id=79f17aec&"
import script from "./StreamMessage.vue?vue&type=script&lang=ts&"
export * from "./StreamMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports